import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import {
  change_pass_reducer,
  update_user_reducer,
  user_auth_reducer,
  user_data_reducer,
  user_register_reducer,
  groups_reducer,
  department_reducer,
  designation_reducer,
  competency_name_reducer,
  competency_statments_reducer,
  competency_type_reducer,
  employees_reducer,
  update_emp_reducer,
  bulk_emp_reducer,
  search_employees_reducer,
  search_employees_by_reducer,
  owner_surveys_reducer,
  owner_surveys_actions_reducer,
  user_surveys_reducer,
  owner_survey_assign_to_user_reducer,
  user_surveys_ans_reducer,
  user_surveys_comp_reducer,
  owner_survey_assign_by_survey_id_reducer,
  role_reducer,
  company_reducer,
  market_share_reducer,
  industry_reducer,
  annual_revenue_reducer,
  total_head_count_reducer,
  permission_reducer,
  org_data_reducer,
  org_simple_data_reducer,
  ans_sub_state_reducer,
  communication_reducer,
  search_employees_by_id_reducer,
  lock_reducer,
  dashboardReducer,
  rating_reducer,
} from "./Reducers";

const reducer = combineReducers({
  user_reg: user_register_reducer,
  user_auth: user_auth_reducer,
  user_data: user_data_reducer,
  update_user: update_user_reducer,
  change_pass: change_pass_reducer,

  employees: employees_reducer,
  update_emp: update_emp_reducer,
  bulk_emp: bulk_emp_reducer,
  search_emp: search_employees_reducer,
  search_emp_by: search_employees_by_reducer,
  search_employees_by_id: search_employees_by_id_reducer,
  lock: lock_reducer,

  groups: groups_reducer,
  designations: designation_reducer,
  departments: department_reducer,
  competency_types: competency_type_reducer,
  competency_names: competency_name_reducer,
  competency_statements: competency_statments_reducer,

  owner_surveys: owner_surveys_reducer,
  owner_surveys_actions: owner_surveys_actions_reducer,
  ans_sub_state: ans_sub_state_reducer,
  role: role_reducer,
  company: company_reducer,
  market_share: market_share_reducer,
  industry: industry_reducer,
  annual_revenue: annual_revenue_reducer,
  total_head_count: total_head_count_reducer,

  // user list
  owner_survey_assign_to_user: owner_survey_assign_to_user_reducer,
  //survey assign by survey id
  owner_survey_assign_by_survey_id: owner_survey_assign_by_survey_id_reducer,

  ///////////////////////////////////
  user_surveys: user_surveys_reducer,
  //draft
  user_surveys_ans: user_surveys_ans_reducer,
  //comp
  user_surveys_comp: user_surveys_comp_reducer,
  //organization

  org_data: org_data_reducer,
  org_simple_data:org_simple_data_reducer,
  //permission
  permission: permission_reducer,
  communication: communication_reducer,
  dashboard: dashboardReducer,
  rating: rating_reducer
});
let initialState = {};

const middleWare = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleWare))
);

export default store;
